import styled from 'styled-components';

import CloseIconSvg from '../../assets/icons/icon-close.svg?react';
import ToggleCheckIconSvg from '../../assets/icons/icon-my-page-toggle-check.svg?react';

import { BaseButton } from './base-primitives.styles';

type StatusToggleProps = {
  ariaLabel: string;
  checked: boolean;
  className?: string;
  onToggle: (nextChecked: boolean) => void;
};

const ToggleTrack = styled(BaseButton)<{ $checked: boolean }>`
  width: ${({ theme }) => theme.scale.px(59)};
  height: ${({ theme }) => theme.scale.px(32)};
  border-radius: ${({ theme }) => theme.scale.px(17)};
  background: ${({ theme }) => theme.colors.surface.tertiary};
  display: flex;
  justify-content: ${({ $checked }) => ($checked ? 'flex-end' : 'flex-start')};
  align-items: center;
  padding: ${({ theme }) => theme.scale.px(2)};
  box-sizing: border-box;
  flex: 0 0 auto;
`;

const ToggleCheck = styled(ToggleCheckIconSvg).attrs({
  'aria-hidden': true,
  focusable: 'false',
})`
  width: ${({ theme }) => theme.scale.px(28)};
  height: ${({ theme }) => theme.scale.px(28)};
  display: block;
`;

const ToggleCross = styled(CloseIconSvg).attrs({
  'aria-hidden': true,
  focusable: 'false',
})`
  width: ${({ theme }) => theme.scale.px(28)};
  height: ${({ theme }) => theme.scale.px(28)};
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.support.dangerSoft};
  padding: ${({ theme }) => theme.scale.px(7)};
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.surface.subtle};
  display: block;

  & path {
    stroke: currentColor;
  }
`;

export function StatusToggle({
  ariaLabel,
  checked,
  className,
  onToggle,
}: StatusToggleProps) {
  return (
    <ToggleTrack
      className={className}
      type="button"
      aria-label={ariaLabel}
      aria-pressed={checked}
      $checked={checked}
      onClick={() => onToggle(!checked)}
    >
      {checked ? <ToggleCheck /> : <ToggleCross />}
    </ToggleTrack>
  );
}
